const r={equals:function(r,e){if(r.size!==e.size)return!1;for(const n of r)if(!e.has(n))return!1;return!0}};export{r as set};
